import React, { useState } from "react";
import { Button, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { Controller } from "react-hook-form";
import Typeahead from "../../../../CommonElements/TypeAhead/index";
import { MetaDescription, MetaTitle, Next } from "../../../../Constant";
import { duedateOptions } from "../../../Company/Duedate";

const SEOForm = ({ register, control, setNextTab }) => {

  return (
    <CardBody>
      <Row className="g-3">
        <Col md="6">
          <FormGroup>
            <Label htmlFor="prefix">{MetaTitle}</Label>
            <input className="form-control" type="text" name="metaTitle" {...register("metaTitle")} />
          </FormGroup>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Label className="form-label pt-3">{MetaDescription}</Label>
          <Controller
            name="metaDescription"
            control={control}
            render={({ field }) => (
              <textarea
                className="form-control"
                {...field}
                rows="3"
                maxLength={500}
              />
            )}
          />
        </Col>
      </Row>

      <Row className="g-3">
        {/* <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="quantityname">{QuantityName}</Label>
            <Controller
              name="quantityname"
              control={control}
              render={({ field }) => (
                <Typeahead
                  id="quantityname"
                  options={quantityOptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}
                />
              )}
            />
          </FormGroup>
        </Col> */}
      </Row>
      <Row>
        {/* <Col md="6">
          <Label className="form-label">Icon</Label>
          <Controller
            name="icon"
            control={control}
            render={({ field }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Col md="8">
                  <input
                    {...register("icon")}
                    className="form-control fileInputStyle"
                    type="file"
                    onChange={handleIconChange}
                    accept=".png, .jpg, .jpeg"
                  />
                </Col>
                <Col md="4">
                  <span className="imagestyle">
                    {icon &&
                    <img
                      src={URL.createObjectURL(icon)}
                      alt="icon"
                      width="40px"
                      height="40px"
                    />
                     } 
                  </span>
                </Col>
              </div>
            )}
          />
        </Col> */}
      </Row>
      <Row className="g-3 pt-3">
        <div className="text-end">
          <Button className="tab-button" onClick={() => setNextTab("4")}>{Next}</Button>
        </div>
      </Row>
    </CardBody>
  );
};

export default SEOForm;
